// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2NbmE","title":"BackImages_title__1u3zZ","images":"BackImages_images__3pgrt"};